import React, { useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogHeaderWithClose from '../basic/DialogHeaderWithClose';
import Button from '../basic/Button';

const isTabletDevice = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 1;
  const isIPad = /ipad/.test(ua) || (navigator.platform === 'MacIntel' && isTouchScreen);
  const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua);
  const isTabletSize = window.innerWidth >= 768 && window.innerWidth <= 1200;

  return isIPad || isAndroidTablet || isTabletSize;
};

const DialogInputNew = (props) => {
  const {
    open,
    handleClose,
    contentStyle,
    className,
    title,
    children,
    actions,
    sx,
    titleClass,
    noCancel,
    ...rest
  } = props;

  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [paddingBottom, setPaddingBottom] = React.useState('0px');

  const originalHeightRef = useRef(window.innerHeight);
  const isTablet = useRef(isTabletDevice());

  useEffect(() => {
    if (!isTablet.current) return;

    const handleResize = () => {
      const heightDiff = originalHeightRef.current - window.innerHeight;
      setKeyboardVisible(heightDiff > 120);
    };

    const handleFocus = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        setIsInputFocused(true);
      }
    };

    const handleBlur = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        setIsInputFocused(false);
      }
    };

    window.addEventListener('focusin', handleFocus);
    window.addEventListener('focusout', handleBlur);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('focusin', handleFocus);
      window.removeEventListener('focusout', handleBlur);
    };
  }, []);

  const shouldAddPadding = isTablet.current && isInputFocused;

  useEffect(() => {
    setPaddingBottom(shouldAddPadding ? '300px' : '0px');
  }, [keyboardVisible, isInputFocused]);

  const dialogStyles = {
    maxWidth: 'unset',
    position: 'absolute',
    ...contentStyle,
  };

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          ...dialogStyles,
        },
        ...sx,
      }}
      PaperProps={{
        style: {
          transform: 'none',
          overflowY: 'auto',
          position: 'relative',
          transition: 'padding-bottom 0.3s ease',
        },
      }}
      className={`dialog ${className || ``}`}
      open={open}
      onClose={handleClose}
      {...rest}
    >
      {title && (
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <DialogHeaderWithClose text={title} handleClose={handleClose} classicClass={titleClass} noCancel />
        </DialogTitle>
      )}
      <DialogContent style={{ maxHeight: 'unset', overflowY: 'auto' }}>
        {children}
      </DialogContent>
      {actions && (
        <DialogActions>
          {!noCancel && (
            <Button
              key={1}
              name="CancelButton"
              label="Cancel"
              primary={true}
              className="btn-space btnCancel"
              onTouchTap={handleClose}
            />
          )}
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogInputNew;